module.exports = __webpack_public_path__ + "img/choose-action-bar-4.21e9841c.png";